import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  viewAllTo?: string;
  viewAllLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  viewAllTo,
  viewAllLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-block text-xs md:text-sm font-medium text-secondary-600 mb-2 tracking-wide">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-extrabold text-xl md:text-3xl text-foreground-950">
          {title}
        </h2>
        {desc && <p className="text-sm text-foreground-600 mt-2 max-w-2xl">{desc}</p>}
      </div>
      {viewAllTo && (
        <Link
          to={viewAllTo}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap shrink-0"
        >
          {viewAllLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}